import { SubscriptionName } from '@anm/api/modules/subscription';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  subscriptionActions,
  subscriptionSelectors
} from '../../../../store/modules/subscription';

const useSubscriptionCalculate = (
  coupon?: string,
  subscriptionName?: SubscriptionName
) => {
  const dispatch = useDispatch();
  const calculation = useSelector(
    subscriptionSelectors.selectSubscriptionCalculate
  );

  const isSubscriptionCalculatePending = useSelector(
    subscriptionSelectors.selectSubscriptionCalculatePending
  );

  useEffect(() => {
    if (!subscriptionName) return;

    dispatch(
      subscriptionActions.fetchSubscriptionCalculate({
        coupon,
        name: subscriptionName
      })
    );
  }, [subscriptionName, coupon]);

  return [calculation, isSubscriptionCalculatePending] as const;
};

export default useSubscriptionCalculate;
